import { required, sameAs } from 'vuelidate/lib/validators';
import abstractValidatorMixin from '../abstractValidator.mixin';

export default {
    mixins: [abstractValidatorMixin],

    data() {
        return {
            serverErrors: {
                oldPassword: [],
                newPassword: [],
                newPasswordRepeat: []
            }
        };
    },

    validations: {
        formData: {
            oldPassword: { required },
            newPassword: { required },
            newPasswordRepeat: {
                required,
                sameAsPassword: sameAs('newPassword')
            }
        }
    },

    computed: {
        oldPasswordErrors() {
            return this.checkErrors(
                'oldPassword',
                'formData',
                'editUserInformation.validators.'
            );
        },
        newPasswordErrors() {
            return this.checkErrors(
                'newPassword',
                'formData',
                'editUserInformation.validators.'
            );
        },
        newPasswordRepeatErrors() {
            return this.checkErrors(
                'newPasswordRepeat',
                'formData',
                'editUserInformation.validators.'
            );
        }
    }
};
